






























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import Navigation from "@/components/Navigation.vue";
import { NavigationItem } from "@/model/NavigationItem";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import { Getter, Action } from "vuex-class";
import requestService from "@/service/requestService";
import { NavigationItemParam } from "@/model/NavigationItemParam";
import * as util from "@/service/util";
import { SubHeaderData } from "@/model/SubHeaderData";
import { InspectTime } from "@/model/InspectTime";
import { SpentTime } from "@/model/SpentTime";
import { SeibiItem } from "@/model/InspectionSeibi";
import { INSPECT_TYPE } from "@/model/InspectType";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import SideTabRight from "@/components/SideTabRight.vue";
/** 2021-07-14 sh #7289 if change shaken menu, it show notification. [START] */
import { MESSAGE } from "@/model/Message";
/** 2021-07-14 sh #7289 if change shaken menu, it show notification. [END] */

@Component({
  components: {
    Header,
    SubHeader,
    Navigation,
    appSideTabRight: SideTabRight
  }
})
export default class MainInspection extends Vue {
  activePage: number = 0;
  navItems: NavigationItem[] = [];
  isUserMode: boolean = true;
  line: string = "3";
  title: string = "";
  textTopTitle: string = "";
  hasBtn: boolean = false;
  reqService: requestService;
  sktControll: SocketControllers;
  startTime: number = 0;
  clientStartTime: number = 0;
  timerSpentTime: any = null;
  expectedTimer: number = 0;
  isEditPrice: boolean = false;
  isUserConfirmPayment: boolean = false;
  userService: UserService;
  canEditSoukou: boolean = false;

  onUserConfirmUpdating: boolean = false;
  optionCouponUpdating: boolean = false; // 更新処理中フラグ（手数料/オプション（通常版）、保証（NEX版）、クーポン（両方））

  @Getter("getInspectLine", { namespace: "InspectionDetail" })
  inspectLine: any;
  @Action("restoreState", { namespace: "ReservationDetail" })
  restoreState: any;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Action("setMaintenanceExpectTime", { namespace: "SubHeader" })
  setMaintenanceExpectTime: any;

  @Action("setIsSavePaymente", { namespace: "SubHeader" })
  setIsSavePaymente: any;

  @Getter("isSavePayment", { namespace: "SubHeader" })
  isSavePayment: boolean;

  // for user
  @Getter("isConfirmLegal56", { namespace: "InspectSeibi" })
  isConfirmLegal56: any;
  @Getter("isConfirmRecommend", { namespace: "InspectSeibi" })
  isConfirmRecommend: any;
  @Getter("isConfirm", { namespace: "Shohiyou" })
  isConfirmShohiyou: any;
  @Getter("isConfirm", { namespace: "Coupon" })
  isConfirmCoupon: any;
  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];
  @Getter("isConfirm", { namespace: "Option" })
  isConfirmOption: any;

  @Getter("getSeibiData", { namespace: "InspectSeibi" })
  seibi: any;
  @Getter("getManualSeibiData", { namespace: "InspectSeibi" })
  seibiManual: any;
  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;

  @Action("confirm", { namespace: "Payment" })
  confirmPayment: any;
  @Action("confirm", { namespace: "InspectSeibi" })
  confirmRecommend: any;
  @Action("setSeibiData", { namespace: "InspectSeibi" })
  setSeibiData: any;

  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;

  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */

  /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
  @Action("setState", { namespace: "RouteState" })
  setRouteState: any;
  /** 2021-11-22 sh #7530 improve speed.(for back) [END] */

    @Action("setSeibiData", { namespace: "InspectSeibiAK3" })
  setSeibiAK3Data: any;

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Action("setSeibiMenuCd", { namespace: "InspectionDetail" })
  setSeibiMenuCd: any;

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  $refs!: {
    subHeader: SubHeader;
    nav: Navigation;
    subPage: any;
    sideTab: SideTabRight;
  };
  created() {
    if (!this.uketsukeCd) {
      this.restoreState();
    }
    this.reqService = new requestService();
    this.sktControll = new SocketControllers();
    this.userService = new UserService();
    this.isUserMode = this.$route.meta == "user";
    this.sktControll.connectSocket(this.onConnect);

    if (this.inspectLine && this.inspectLine.length > 0) {
      this.line = this.inspectLine[0].kbnKey;
    }
    this.getNavigation();
    if (this.isUserMode) {
      this.title = "車検の進行状況";
    }
  }

  getNavigation() {
    this.reqService
      .getNavigation(this.uketsukeExtendsId, this.isUserMode)
      .then((res: any) => {
        this.$set(this, "navItems", res);
      });
  }

  setStartTime() {
    this.clientStartTime = new Date().getTime();
    this.reqService.asyncGetServerTime().then(time => {
      this.startTime = time;
    });
  }

  setTimerSpentTime() {
    this.clearTimerSpentTime();
    let interval = 60000;
    var dt = new Date().getTime() - this.clientStartTime;
    if (dt <= interval) {
      this.timerSpentTime = setTimeout(
        this.saveSpentTime,
        Math.max(0, interval - dt)
      );
    }
  }

  clearTimerSpentTime() {
    if (this.timerSpentTime) {
      clearTimeout(this.timerSpentTime);
      this.timerSpentTime = null;
    }
  }

  onActive(pageName: string) {
    if (this.$route.name === "carselection") {
      this.canEditSoukou = true;
    } else {
      this.canEditSoukou = false;
    }
    if (pageName === "estimate") {
      this.updateTSknUketsukeExtends();
    }
    this.$forceUpdate();
    if (this.navItems.length == 0) {
      setTimeout(() => {
        this.onActive(pageName);
      }, 500);
      return;
    }
    this.$refs.nav.checkLockNavigation();
    const page = this.findPageNumber(pageName);
    if (page > -1) {
      this.setStartTime();
      this.setTimerSpentTime();
      this.activePage = page;
      const item = this.navItems[this.activePage];
      if (item.status == NAVIGATION_STATUS.INACTIVE) {
        item.status = NAVIGATION_STATUS.ACTIVE;
        /** 2022-02-04 sh #7710 duplicate send. [START] */
        // this.sendPutNavigation(item);
        /** 2つのリクエストが送信されるので、タイミングをずらすようにする */
        setTimeout(() => {
          this.sendPutNavigation(item);
        }, 1000);
        /** 2022-02-04 sh #7710 duplicate send. [END] */
      }
      if (this.$route.name != item.page) {
        // this.$refs.subHeader.getSubHeaderData();
        this.goToPage(item.page);
      }
    }
  }

  onRegister(data: {
    pageName: string;
    status: string;
    notCurrentActive: boolean;
  }) {
    console.log("MainInspection.onRegister data => ", data, this.activePage, this.navItems);
    this.clearTimerSpentTime();
    const page = this.findPageNumber(data.pageName);
    if (page == this.activePage) {
      if (this.activePage < this.navItems.length - 1) {
        let status = data.status;
        if (!data.status) {
          status = NAVIGATION_STATUS.REGISTER;
        }
        this.navItems[this.activePage].status = status;
        this.updateWorkProgressState();
        this.sendPutNavigation(this.navItems[this.activePage]);
        if (this.navItems[this.activePage].page == "legal56") {
          this.goToStandbyPage();
        } else if (this.navItems[this.activePage].page == "recmaintenance") {
          this.$router.push({ name: "partsselect" });
        } else if (this.navItems[this.activePage].page == "partsselect") {
          let page = this.isSavePayment ? "3" : "2";
          this.$router.push({
            name: "standby",
            params: { page: page }
          });
        } else {
          this.activePage++;
          const item = this.navItems[this.activePage];
          this.onActive(item.page);
        }
      } else {
        this.navItems[this.activePage].status = NAVIGATION_STATUS.REGISTER;
        this.sendPutNavigation(this.navItems[this.activePage]);
        this.$router.push({ name: "additional-maintenance" });
      }
    } else if (data.notCurrentActive) {
      /** 2021-08-17 sh #7342 fix script error for implements jizen mitsumori. [START] */
      if (page > -1) {
        this.navItems[page].status = NAVIGATION_STATUS.REGISTER;
        this.sendPutNavigation(this.navItems[page]);
      }
      /** 2021-08-17 sh #7342 fix script error for implements jizen mitsumori. [END] */
    /** 2021-11-25 sh #7570 Pressing a button, it does not work. [START] */
    } else if (data.pageName == "estimate" && this.activePage == 3) {
      /** 現車確認から事前見積もりの見積結果画面へ戻った場合、activePageを減らす */
      this.activePage--;
      this.onRegister(data);
    /** 2021-11-25 sh #7570 Pressing a button, it does not work. [END] */
    }
  }

  findPageNumber(pageName: string) {
    return this.navItems.findIndex(
      (nav: NavigationItem) => nav.page == pageName
    );
  }

  onChangePage(page: number) {
    this.activePage = page;
    const navItem = this.navItems[page];
    if (navItem && navItem.page) {
      this.onActive(navItem.page);
    }
  }

  goToPage(page: string | undefined) {
    /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
    if (page == "currentcarcheck") {
      this.setRouteState( {date: {}, index: INSPECT_TYPE.GENSHA} );
    } else if (page == "legal56") {
      this.setRouteState( {date: {}, index: INSPECT_TYPE.LEGAL56} );
    } else if (page == "jizen") {
      this.setRouteState( {date: {}, index: INSPECT_TYPE.JIZEN} );
    } else if (page == "recmaintenance") {
      this.setRouteState( {date: {}, index: INSPECT_TYPE.RECOMMEND} );
    }
    /** 2021-11-22 sh #7530 improve speed.(for back) [END] */
    this.$nextTick(() => {
      this.$router.push({ name: page });
    });
  }

  goToStandbyPage() {
    this.clearTimerSpentTime();
    this.$router.push({ name: "standby", params: { page: "1" } });
  }

  startMaintenance() {
    this.$refs.subHeader.setMaintenanceMinute();
  }

  sendPutNavigation(item: NavigationItem, retCnt: any = 0) {
    const param: NavigationItemParam = {
      uketsukeExtendId: this.uketsukeExtendsId,
      screenId: item.screenId,
      status: item.status
    };
    this.reqService.putNavigation(param).then(
      (res: any) => {},
      (error: any) => {
        /** 2021-12-13 sh #7557 fix dead lock. [START] */
        // console.log("save navigation error wait 1s to auto retry");
        // setTimeout(() => {
        //  this.sendPutNavigation(item);
        // }, 1000);
        if (error && error.status && error.status == 409 && retCnt < 10) {
          /** 409のステータスが発生した時だけ、リトライする。最大：10回まで(dead lock.) */
          setTimeout(() => {
            retCnt++;
            console.log("save navigation error wait 1s to auto retry", retCnt);
            this.sendPutNavigation(item, retCnt);
          }, 1000);
        }
        /** 2021-12-13 sh #7557 fix dead lock. [END] */
      }
    );
  }

  onConnect() {
    if (this.uketsukeCd && this.uketsukeExtendsId) {
      if (this.isUserMode) {
        this.sktControll.socketCustomerNavigations(this.onUpdateNavigation);
        this.sktControll.socketInspectBuhinChange(this.onBuhinNotify);
        this.sktControll.socketCustomerKensaHiyou(this.onReloadKensaHiyou);
        this.sktControll.socketShohiyouReload(this.socketShohiyouRollback);
        this.sktControll.socketReservationInspection(this.onStartInspect);
        this.sktControll.socketShohiyouCompleted(this.onUpdateShouhiyou);
        this.sktControll.socketCoupon(this.onUpdateCoupon);
        this.sktControll.socketInspections(this.onInspectionDotenken);
        this.sktControll.socketOption(this.onUpdateOption);
        this.sktControll.socketJizenRecommend(this.onInspectionDotenken);
        // memo [start] ほぼ同タイミングで実行されるが、socketInspectSeibiの中身がsocketInspectに送られることが稀にある
        this.sktControll.socketInspect(this.onInspectItemcompleted);//内容分離推奨
        this.sktControll.socketInspectSeibi(this.onSeibiItemcompleted);
        // memo [end]
      }
      this.sktControll.socketPayments(this.onPayments);
    }
  }

  socketShohiyouRollback(frame: any){
    //複数のソケット通信をしているので処理をまとめる
    if (this.isUserMode) {
      this.onReloadShouhiyou(frame);
    }else{
      /** ユーザ画面で車検の種類が変更された場合の処理を行う. */
      this.onReloadAfterShakenShurui(frame);
    }

  }

  onInspectItemcompleted(frame: any) {
    const body = util.getWSData(frame);
    const seibi = { ...body };
    delete seibi.sknWorkProgressState;
    delete seibi.sknWorkProgressStateNm;
    this.setSeibiAK3Data(seibi);
    //this.notify();
    // this.loopFirstDoTenken(this.listInspect[1]);
  }

  onSeibiItemcompleted(frame: any) {
    const body = util.getWSData(frame);
    const seibi = { ...body };
    delete seibi.items.sknWorkProgressState;
    delete seibi.items.sknWorkProgressStateNm;
    this.setSeibiData(seibi);
  }

  onUpdateShouhiyou(frame: any) {
    if (sessionStorage.saveShohiyou == null) {
      this.userService.getShohiyou();
    } else {
      sessionStorage.removeItem("saveShohiyou");
    }
    const body = util.getWSData(frame);
    this.userService.updateConfirm(body.sknUketsukeUserJouhou);
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  onReloadAfterShakenShurui(frame: any) {
    const body = util.getWSData(frame);
    if (body && body.shakenShuruiSeibiMenuCd) {
      if (body.screen && body.screen != this.$route.meta) {
        this.setSeibiMenuCd(body.shakenShuruiSeibiMenuCd);
      }
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  onUpdateCoupon(frame: any) {
    this.userService.getCoupon();
    const body = util.getWSData(frame);
    this.userService.updateConfirm(body.sknUketsukeUserJouhou);
  }

  onPayments(frame: any) {
    const body = util.getWSData(frame);
    const maintenaceMinute = body.sknMaintenanceExpectTime.toFixed(0);
    this.setMaintenanceExpectTime(body.sknMaintenanceExpectTime);
    this.$refs.subHeader.setMaintenanceMinute();
    this.$refs.subHeader.setMaintenanceZero();
    this.setIsSavePaymente();
    if (this.$route.name == "standby") {
      this.$router.push({ name: "standby", params: { page: "3" } });
    }
    if (this.isUserMode) {
      if (this.isUserConfirmPayment) {
        this.$router.push({ name: "usercomplete" });
      } else {
        this.isUserConfirmPayment = false;
      }
    }
  }

  onUpdateNavigation(frame: any) {
    const body = util.getWSData(frame);
    this.navItems = body;
    if (this.navItems && this.navItems.length !== 0) {
      if (this.navItems[3].status == "2" && this.isUserMode) {
        const listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);
        if (listRecommend.length === 0) {
          this.confirmRecommend({ type: INSPECT_TYPE.RECOMMEND, value: 1 });
        }
      }
    }
  }

  saveSpentTime(doClearTimer?: boolean) {
    let now = new Date().getTime();
    let stopTime = this.startTime + (now - this.clientStartTime);
    this.clientStartTime = now;
    if (doClearTimer) {
      this.clearTimerSpentTime();
    } else {
      this.setTimerSpentTime();
    }
    let nav = this.navItems.filter(nav => nav.page == this.$route.name);
    let screenId = "";
    if (nav.length > 0) {
      screenId = nav[0].screenId;
    }

    console.log(
      "saveSpentTime screenId " + screenId,
      stopTime - this.startTime
    );
    if (screenId == "") {
      this.clearTimerSpentTime();
    } else {
      const spent: SpentTime = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        startTime: this.startTime,
        stopTime,
        screenId,
        uketsukeCd: this.uketsukeCd,
        yoyakuNo: this.yoyakuNo
      };
      this.reqService.saveSpentTime(spent).then(
        res => {
          this.startTime = stopTime;
          if (!this.sktControll.checkSocket()) {
            this.$refs.subHeader.getSubHeaderData();
          }
        },
        error => {
          if (stopTime - this.startTime >= 60000) {
            if (screenId == "6") {
              // maintenance
              this.$refs.subHeader.setTempMaitenaceMinute();
            } else {
              // inspect
              this.$refs.subHeader.setTempInspectMinute();
            }
          }
        }
      );
    }
  }

  /** 2021-06-02 sh #7123 if change price, get the flag form server. [START] */
  onUserConfirmSync() {
    /** サーバ側と同期をするためここで再読み込みをする */
    let promise = this.userService.getConfirmPM();
    Promise.all([promise]).then((val: any) => {
      this.onUserConfirm();
    });
  }
  /** 2021-06-02 sh #7123 if change price, get the flag form server. [END] */

  onUserConfirm() {

    let listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);
    if (
      this.isConfirmShohiyou &&
      this.isConfirmOption &&
      this.isConfirmCoupon &&
      this.isConfirmLegal56 &&
      (listRecommend.length == 0 || this.isConfirmRecommend)
    ) {
      this.$set(this, "onUserConfirmUpdating", true);
      const dataForSave = this.userService.getDataForSaveAk7(
        this.seibi,
        this.seibiManual,
        this.sumPrice(INSPECT_TYPE.LEGAL56),
        this.sumPrice(INSPECT_TYPE.RECOMMEND)
      );
      this.isUserConfirmPayment = false;
      this.reqService.savePayment(dataForSave).then(res => {
        this.$set(this, "onUserConfirmUpdating", false);
        this.confirmPayment(1);
      });
    }
  }

  onConfirmPayment() {
    this.isUserConfirmPayment = true;
  }

  updateWorkProgressState() {
    if (["MD0004", "MD0006", "MD0008"].indexOf(this.navItems[this.activePage].screenCd) > -1) {
      const data = {
        screenCd: this.navItems[this.activePage].screenCd,
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        currentWorkProgressState: this.stateId,
        uketsukeCd: this.uketsukeCd,
        yoyakuNo: this.yoyakuNo
      };
      this.reqService.updateWorkProgressState(data);
    }
  }

  onBuhinNotify(frame: any) {
    const list = util.getWSData(frame);
    list.forEach((buhin: any) => {
      setTimeout(() => {
        this.$notify({
          title: buhin.buhinNm,
          dangerouslyUseHTMLString: true,
          message: buhin.oldBuhinPrice + "<br/>" + buhin.newBuhinPrice
        });
      }, 300);
    });
  }

  destroyed() {
    this.sktControll.freeSocketResources();
    /** 2021-07-16 sh #7190 clear timer [START] */
    this.clearTimerSpentTime();
    /** 2021-07-16 sh #7190 clear timer [END] */
  }

  onActiveSideTab(index: number) {
    if(this.$refs.sideTab) {
      this.$refs.sideTab.onActive(index);
    }
  }

  onConfirmSideTab(index: number) {
    if(this.$refs.sideTab) {
      this.$refs.sideTab.onConfirm(index);
    }
  }

  onUpdateSideTab(index: number) {
    if(this.$refs.sideTab) {
      this.$refs.sideTab.onUpdate(index);
    }
  }

  /** 2021-07-14 sh #7289 if change shaken menu, it show notification. [START] */
  onReloadShouhiyou(frame: any) {
    this.userService.getShohiyou();
    const body = util.getWSData(frame);
    this.userService.updateConfirm(body.sknUketsukeUserJouhou);
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedShakenCouse
    });
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.userService.getSeibi();
    if (this.isUserMode && body.shakenShuruiSeibiMenuCd) {
      this.setSeibiMenuCd(body.shakenShuruiSeibiMenuCd);
    }
    if (this.$route.name == "statusresult") {
      this.onReloaseShohiyouWithSettimeiout();
    } else if (this.$route.name == "workdetail") {
      this.onReloaseShohiyouWithSettimeiout();
    }
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  }
  /** 2021-07-14 sh #7289 if change shaken menu, it show notification. [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  onReloaseShohiyouWithSettimeiout(msec: number = 1000) {
    setTimeout(() => {
      this.userService.getSeibiAK3();
    }, msec);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  /** 2021-08-17 sh #7343 get seibi after recieved socket. [START] */
  onInspectionDotenken() {
    this.userService.getSeibi();
  }
  /** 2021-08-17 sh #7343 get seibi after recieved socket. [END] */

  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
  onReloadKensaHiyou() {
    if (this.isUserMode) {
      const promise = this.userService.getKensaHiyouPM();
      Promise.all([promise]).then(() => {});
    }
  }
  /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */
  updateTSknUketsukeExtends() {
  this.reqService.updateTSknUketsukeExtends(this.uketsukeExtendsId).then(
    (res: any) => {
    },
    (err: any) => {
    }
  );
  }

  /** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
  onUpdateOption(){
    this.userService.getOption();
  }
  /** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  onStartInspect(frame: any) {
    const body = util.getWSData(frame);
    if (body && body.seibiMenuCd) {
      this.setSeibiMenuCd(body.seibiMenuCd);
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  onSelect() {
    // 右サイドバークリック時に、遷移前のページがクーポンまたはオプションの場合は一時保存する
    if ((this.$route.name === 'discountcoupon' || this.$route.name === 'option') && typeof this.$refs.subPage.onSave === 'function') {
      this.$refs.subPage.onSave();
    }
  }

  async onOptionCouponUpdating(promise: Promise<any>) {
    // オプションまたはクーポン保存時に右サイドバーを無効化する
    this.optionCouponUpdating = true;
    await promise;
    this.optionCouponUpdating = false;
  }
}
